import { render } from "./YourData.vue?vue&type=template&id=902889fe&scoped=true&ts=true"
import script from "./YourData.vue?vue&type=script&lang=ts"
export * from "./YourData.vue?vue&type=script&lang=ts"

import "./YourData.vue?vue&type=style&index=0&id=902889fe&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902889fe"]])

export default __exports__